import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <h1>Privacy Policy</h1>
        <p className="effective-date">Effective Date: May 07, 2026</p>

        <p>
          Welcome to <span>SaPra</span>.
        </p>

        <p>
          We value your privacy and are committed to protecting your
          personal information.
        </p>

        <section>
          <h2>Information We Collect</h2>
          <p>We may collect the following information:</p>

          <ul>
            <li>Name</li>
            <li>Mobile number</li>
            <li>Email address</li>
            <li>Shipping and billing address</li>
            <li>Payment details</li>
            <li>Order history</li>
          </ul>
        </section>

        <section>
          <h2>How We Use Your Information</h2>
          <p>Your information is used for:</p>

          <ul>
            <li>Processing orders</li>
            <li>Shipping products</li>
            <li>Customer support</li>
            <li>Sending order updates</li>
            <li>Improving our services</li>
          </ul>
        </section>

        <section>
          <h2>Payment Security</h2>
          <p>
            Payments are securely processed through trusted payment gateways.
            We do not store your card or banking information on our servers.
          </p>
        </section>

        <section>
          <h2>Sharing of Information</h2>
          <p>
            We do not sell or rent customer information to third parties.
          </p>

          <p>Information may be shared only with:</p>

          <ul>
            <li>Delivery partners</li>
            <li>Payment gateway providers</li>
            <li>Legal authorities when required</li>
          </ul>
        </section>

        <section>
          <h2>Cookies</h2>
          <p>
            Our website may use cookies to improve user experience and
            website functionality.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>

          <p>For any privacy-related concerns, contact us:</p>

          <div className="contact-box">
            <p>Email: support@sapra.com</p>
            <p>Phone: +91 9876543210</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;